import { computed, unref } from 'vue';

import { propsFactory, paramCase } from '@components/utils';

import type { ComputedRef, PropType } from 'vue';

export interface ITransparentProps {
  transparent: boolean;
}
export interface IUseTransparentProps {
  transparentClasses: ComputedRef<string | undefined>;
}

export const makeTransparentProps = propsFactory(
  {
    /**
     * Позволяет использовать компонент на прозрачном фоне
     */
    transparent: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  'invert-color'
);

export function useTransparent(props: ITransparentProps, name: string): IUseTransparentProps {
  const transparentClasses = computed(() => {
    const { transparent } = unref(props);
    return transparent ? `${paramCase(name)}--transparent` : undefined;
  });

  return { transparentClasses };
}
